<template>
    <div class="dropdown filter_item">
        <button class="btn m-r-5 btn-default waves-effect waves-light dropdown-toggle" :class="{'btn-success': efilter_touched}" type="button" data-toggle="dropdown">
            Regras
        </button>

        <div class="dropdown-menu dropdown-menu-right arrow-dropdown-menu arrow-menu-right dropdown-lg">
            <p class="h5 m-b-15">Regras</p>
            <div class="form-group">
                <div v-for="rule in rules" :key="rule.id" class="checkbox checkbox-success">
                    <input :name="'rule_' + rule.id"
                            :id="'rule_' + rule.id"
                            type="checkbox"
                            :value="rule.id"
                            v-model="model">
                    <label :for="'rule_' + rule.id">
                        {{ rule.name }}
                    </label>
                </div>
            </div>

            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.$store.getters.getFilter.rules || [],
        }
    },
    watch: {
        selected_rules: {
            handler(newVal) {
                this.model = newVal;
            },
        }
    },
    computed: {
        rules() {
            return this.$store.getters.getRules;
        },
        selected_rules() {
            return this.$store.getters.getFilter.rules || [];
        },
        efilter_touched: function () {
            return (
                this.selected_rules.length > 0
            )
        },
    },
    methods: {
        filter() {
            this.$store.commit('setFilter', {
                rules: this.model
            });
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    }
}
</script>